import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Slider from 'react-slick';

import {
  SliderFullWidth,
  Slide,
  SLiderGImage,
  CloseButton,
  SliderWrapper,
} from './styles/FullWidthSlider.styled';

export default function ImageCarousel({ data, id, dir }) {
  const settings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    autoplay: false,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 3,
          infinite: true,
          centerMode: true,
          centerPadding: '30px',
          adaptiveHeight: false,
          variableWidth: true,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          infinite: true,
          centerMode: true,
          centerPadding: '30px',
          adaptiveHeight: false,
          variableWidth: true,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          infinite: true,
          centerMode: true,
          centerPadding: '30px',
          adaptiveHeight: true,
          variableWidth: true,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          infinite: true,
          centerMode: true,
          centerPadding: '30px',
          adaptiveHeight: true,
          variableWidth: true,
        },
      },
      {
        breakpoint: 675,
        settings: {
          arrows: false,
          slidesToShow: 1,
          autoplay: true,
          infinite: true,
          centerMode: true,
          centerPadding: '30px',
          adaptiveHeight: true,
          variableWidth: true,
        },
      },
      {
        breakpoint: 400,
        settings: {
          arrows: false,
          slidesToShow: 1,
          autoplay: true,
          infinite: true,
          centerMode: true,
          centerPadding: '30px',
          adaptiveHeight: true,
          variableWidth: true,
        },
      },
    ],
  };
  const { carouselImages } = data;
  const [activeButton, setActiveButton] = useState(true);
  return (
    <SliderWrapper className="slider_img_wrapper" id={`${id}carousel-wrapper`}>
      <SliderFullWidth id={id} className="img_full_width" dir={dir}>
        <Slider {...settings}>
          {isEmpty(carouselImages) ||
            carouselImages.map((image) => (
              <Slide>
                <SLiderGImage>
                  <LazyLoadImage
                    src={image.url}
                    width={306}
                    height={321}
                    effect="blur"
                    onClick={() => {
                      setActiveButton(image);
                    }}
                    placeholderSrc={image ? `${image.url}?width=50&quality=50` : null}
                  />
                </SLiderGImage>

                <div className={activeButton === image ? 'bimg active' : 'bimg'}>
                  <LazyLoadImage
                    src={image.url}
                    effect="blur"
                    placeholderSrc={image ? `${image.url}?width=50&quality=50` : null}
                  />
                  <CloseButton onClick={() => setActiveButton(false)}>&nbsp;</CloseButton>
                </div>
              </Slide>
            ))}
        </Slider>
      </SliderFullWidth>
    </SliderWrapper>
  );
}
